import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  TextField,
  Typography,
} from '@mui/material'
import { UnitLabelType } from '@planning/app/api'
import { PopperWithPlacement } from '@planning/components'
import { useTranslate } from '@tolgee/react'
import { FieldStore } from '@tom-ui/utils'
import { Observer, observer } from 'mobx-react-lite'

export const LabelsAutocomplete = observer(
  ({ fieldStore, required }: { fieldStore: FieldStore<UnitLabelType[]>; required?: boolean }) => {
    const { t } = useTranslate()

    const removeLabel = (label: UnitLabelType) => {
      fieldStore.setValue(fieldStore.value.filter(l => l !== label))
    }

    return (
      <Autocomplete
        multiple
        disableCloseOnSelect
        fullWidth
        ListboxComponent={List}
        options={Object.values(UnitLabelType)}
        getOptionLabel={label => label}
        PopperComponent={PopperWithPlacement}
        slotProps={{
          popper: {
            sx: { minWidth: '16rem' },
          },
        }}
        renderOption={(props, value) => (
          <ListItem {...props}>
            <ListItemIcon>
              <Checkbox
                edge='start'
                checked={fieldStore.value?.includes(value) ?? false}
                disableRipple
              />
            </ListItemIcon>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant='body2'>{t(value)}</Typography>
            </Box>
          </ListItem>
        )}
        value={fieldStore.value}
        renderTags={value => (
          <>
            {value
              .sort((a, b) => a.localeCompare(b))
              .map(label => (
                <Chip
                  key={`other-labels-option-chip-${label}`}
                  label={t(label)}
                  onDelete={() => removeLabel(label)}
                />
              ))}
          </>
        )}
        onChange={(_, assignedCodes) => {
          fieldStore.setValue(assignedCodes)
        }}
        renderInput={params => (
          <Observer>
            {() => (
              <TextField
                required={required}
                {...params}
                sx={{ marginTop: '1rem' }}
                label={`${t('otherLabels', 'Other labels')}`}
                error={!!fieldStore.error}
                helperText={fieldStore.error ? t('fieldIsRequired', 'Field is required.') : ''}
              />
            )}
          </Observer>
        )}
      />
    )
  },
)
